import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicioFormatoAsistencialService, FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity } from '../../services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServicioEntidadService, EntidadEmpresarialEntity } from '../../services/servicio-entidad.service';
import { ServicioParametroSimensService } from '../../services/servicio-parametro-simens.service';
import { LoginEntity } from 'src/app/interfaces/login';

@Component({
  selector: 'app-reporte-formato-asistencial',
  templateUrl: './reporte-formato-asistencial.component.html',
  styleUrls: ['./reporte-formato-asistencial.component.css']
})
export class ReporteFormatoAsistencialComponent implements OnInit, AfterContentChecked {

  canLoad: boolean;

  loading: boolean;
  mensajeError: string;

  filtrosSeleccionados: FiltrosFormatoAsistencialEntity;
  entidad: EntidadEmpresarialEntity;
  datosEncabezado: FormatoAsistencialEntity;
  parametroSimens: any;

  public objetoFiltros: FiltrosFormatoAsistencialEntity = {
    codigoBaseDatos : '',
    archivo : false,
    diligenciados : false,
    evoluciones : false,
    firmaAfiliado : false,
    firmaProfesional : true,
    notas : false,
    solicitudServicios: false,
    marcaAgua : '',
    sede : 0,
    user : ''
  };

  constructor( private activatedRoute: ActivatedRoute,
               private servicioFormato: ServicioFormatoAsistencialService,
               private servicioEntidad: ServicioEntidadService,
               private servicioSimens: ServicioParametroSimensService,
               private changeDetect: ChangeDetectorRef) {
    this.activatedRoute.params.subscribe(params => {
      const evoluciones = Number(params['evoluciones']);
      const servicios = Number(params['servicios']);

      this.objetoFiltros.codigoBaseDatos = params['codigoBaseDatos'];
      this.objetoFiltros.uncoLogin = Number(params['uncoLogin']);
      this.objetoFiltros.tta = Number(params['tta']);
      this.objetoFiltros.sede = Number(params['uncoSede']);
      this.objetoFiltros.evoluciones = evoluciones && evoluciones === 1;
      this.objetoFiltros.solicitudServicios = servicios && servicios === 1;
      this.servicioFormato.clearTemporalWait();
      this.getUsuario();
    });
  }

  ngOnInit() { }

  ngAfterContentChecked(): void {
    this.changeDetect.detectChanges();
  }

  public onFiltrosCompletados(filtros: FiltrosFormatoAsistencialEntity)  {
    this.canLoad = filtros.canLoad;
    if (filtros.canLoad) {
      if (!filtros.canImpresion) {
        this.onPrepareControlImpresion();
      }
      this.loading = true;
      this.filtrosSeleccionados = filtros;
      this.getHeader();
    } else {
      this.onPrepareControlImpresion();
    }
  }

  async getUsuario() {
    try {
      this.loading = true;
      const request = await this.servicioFormato.getInformacionLogin(this.objetoFiltros.codigoBaseDatos, this.objetoFiltros.uncoLogin);
      if (request != null) {
        request.subscribe((login: LoginEntity) => {
          this.objetoFiltros.login = login;
          this.objetoFiltros.user = login.usuario;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getUsuario()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del usuario, reporte caso al administrador`;
        });
      }
    } catch (e) {
      console.error('Catch Reporte-formato-asistencial.getUsuario()', e);
    }
  }

  async getHeader() {
    try {
      const response = await this.servicioFormato.getHeaderFormatoAsistencial(this.filtrosSeleccionados.codigoBaseDatos, this.filtrosSeleccionados.tta);
      if (response != null) {
        response.subscribe((data: FormatoAsistencialEntity) => {
          this.datosEncabezado = data;
          if (data) {
            this.getEntidadEmpresarial();
          } else {
            this.loading = false;
            this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del formato, reporte caso al administrador`;
          }
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getHeader()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del formato, reporte caso al administrador`;
        });
      }
    } catch (e) {
      this.loading = false;
      console.error('Catch getHeader()', e);
      this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del formato, reporte caso al administrador`;
    }
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.filtrosSeleccionados.codigoBaseDatos, this.filtrosSeleccionados.sede);
      if (response != null) {
        response.subscribe((data: any) => {
          if (data) {
            this.entidad = data[0];
            this.filtrosSeleccionados.entidadEmpresarial = this.entidad;
            this.getParametroSimens(this.filtrosSeleccionados.sede);
          } else {
            this.loading = false;
            console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Entidades resueltas nulas ');
            this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
          }
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
        });
      }
    } catch (e) {
      this.loading = false;
      console.error('Catch getEntidadEmpresarial()', e);
      this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
    }
  }

  async getParametroSimens(sede: number) {
    try {
      const response = await this.servicioSimens.getParametroSimensBySede(this.filtrosSeleccionados.codigoBaseDatos, this.filtrosSeleccionados.sede);
      if (response != null) {
        response.subscribe((data: any) => {
          this.parametroSimens = data;
          this.filtrosSeleccionados.parametroSimens = data;
          this.getLogo();
        }, (err: HttpErrorResponse) => {
          this.parametroSimens = null;
          console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Parametro Simens Nulo ');
          console.error('Error getParametroSimens()', err);
        });
      }
    } catch (e) {
      this.parametroSimens = null;
      console.error('Catch getParametroSimens()', e);
      console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Parametro Simens Nulo ');
    }
  }

  async getLogo() {
    try {
      const response = await this.servicioFormato.getLogoEntidadEmpresarial(this.filtrosSeleccionados.codigoBaseDatos, { idEntidad: this.entidad.unco});
      if (response != null) {
        response.subscribe((data: any) => {
          this.entidad.urlLogo = data.source;
          this.loading = false;
          this.mensajeError = null;
        }, (err: HttpErrorResponse) => {
          console.error('Error getLogo()', err);
          this.entidad.urlLogo = '/assets/img/empty.png';
          this.loading = false;
          this.mensajeError = null;
        });
      }
    } catch (e) {
      console.error('Catch getLogo()', e);
      this.entidad.urlLogo = '/assets/img/empty.png';
      this.loading = false;
      this.mensajeError = null;
    }
  }

  onPrepareControlImpresion() {
    window.addEventListener('keydown', (event: any) => {
      if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
        event.preventDefault();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        } else {
            event.stopPropagation();
        }
        return;
      }
    });

    window.addEventListener('keyup', (event: any) => {
      if (event.keyCode === 44) {
        this.copyToClipboard();
      }
    });

    window.addEventListener('contextmenu', (event: any) => {
      event.preventDefault();
    });

  }

  copyToClipboard() {
    const aux = document.createElement('input');
    aux.setAttribute('value', 'Impresiones de pantalla deshabilitadas !');
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    alert('Impresiones de pantalla deshabilitadas !');
  }

}
